// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Signin_wrapper__3D8KJ","logo":"Signin_logo__3xnMd","hostsWrapper":"Signin_hostsWrapper__1kP_D","formWrapper":"Signin_formWrapper__GM9RW"};